import { CONTENT_TYPE, ImageComponent } from "@educaplay/core";
import classes from "./DialogContent.module.scss"
import clsx from "clsx";
import { AudioComponentControl } from "@educaplay/core/components/AudioComponentControl";

export function DialogContent(props) {

    const { mediaType, media, title, description, explanation } = props;

    return (
        <div className={classes.infoContainer}>
            <div className={clsx(classes.disposition, !media && classes.dispositionWithoutImage)}>
                {mediaType === CONTENT_TYPE.IMAGE && (
                    <div className={classes.containerImage}>
                        <ImageComponent source={media} className={classes.image} />
                    </div>
                )}
                {mediaType === CONTENT_TYPE.AUDIO && (
                    <div className={classes.containerAudio}>
                        <AudioComponentControl source={media} className={classes.audio} />
                    </div>
                )}
                <div className={classes.titleanddescriptioncontainer}>

                    <div className={classes.titleContainer}>
                        {title}
                    </div>
                    <div className={classes.descriptionContainer}>
                        {description}
                    </div>
                </div>


            </div>

            <div className={classes.explanationContainer}>
                {explanation}
            </div>

        </div>
    )
}